export const generateModifierString = (baseClass: string, modifier?: string | string[]): string => {
	if (!baseClass) {
		return '';
	}

	if (typeof modifier === 'string') {
		return `${baseClass}--${modifier}`;
	}

	if (Array.isArray(modifier)) {
		return modifier.map((mod: string) => `${baseClass}--${mod}`).join(' ');
	}

	return '';
};

export const generateClassNameString: (baseClass: string, modifier?: string | string[]) => string = (
	baseClass: string,
	modifier?: string | string[]
): string => {
	return `${baseClass} ${generateModifierString(baseClass, modifier)}`;
};
